import React, { Component } from "react";
import Typography from "@material-ui/core/Typography";
import withStyles from "@material-ui/core/styles/withStyles";
import { connect, getIn } from "formik";

export default withStyles({}, { name: "LcStatusField" })(
  connect(
    class StatusField extends Component {
      shouldComponentUpdate = nextProps =>
        nextProps.formik.status !== this.props.formik.status ||
        getIn(nextProps.formik.errors, nextProps.name) !==
          getIn(this.props.formik.errors, this.props.name);

      render = () => {
        const txt =
          this.props.name === "status"
            ? this.props.formik.status
            : getIn(this.props.formik.errors, this.props.name);

        if (!txt) return null;

        return (
          <Typography align="center" color="error" variant="subtitle1">
            {txt}
          </Typography>
        );
      };
    }
  )
);
